export const INFORMATION_DETAIL_FETCH = 'INFORMATION_DETAIL_FETCH';
export const INFORMATION_DETAIL_SUCCESS = 'INFORMATION_DETAIL_SUCCESS';
export const INFORMATION_DETAIL_FAILURE = 'INFORMATION_DETAIL_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/InformationDetail/actionTypes.js